import { appContent } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading mb-3">
                {appContent.title}
              </h2>
              <p className="text-lg md:text-xl font-semibold text-primary-600 mb-4">
                {appContent.subtitle}
              </p>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 max-w-[500px]">
                {appContent.desc}
              </p>

              <div className="flex flex-wrap gap-2 justify-center lg:justify-start mb-6">
                {appContent.features.map((f) => (
                  <span
                    key={f}
                    className="px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium border border-accent-200/60"
                  >
                    {f}
                  </span>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
                {appContent.platforms.map((p) => (
                  <button
                    key={p.label}
                    className="flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap"
                  >
                    <i className={`${p.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
                    <div className="text-left">
                      <div className="text-xs opacity-60">{p.label}</div>
                      <div className="text-xs">{p.desc}</div>
                    </div>
                  </button>
                ))}
              </div>
            </div>

            <div className="flex-shrink-0 w-56 md:w-64">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20news%20app%20interface%20with%20red%20and%20dark%20theme%2C%20breaking%20news%20headlines%2C%20clean%20minimal%20UI%20design%2C%20floating%20on%20a%20warm%20gradient%20background%2C%20professional%20product%20presentation%20style&width=600&height=900&seq=app-mockup-51bl&orientation=portrait"
                alt="51爆料网App界面"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}